// @core/api/endpoints/authn/invalidate_current_tokens.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  InvalidateTokensRequest,
} from '../../../types/authn';

const BASE_PATH = '/authn';

/**
 * Invalidate current tokens (logout)
 * Revokes the current access and refresh tokens, effectively logging out the user from the current session while keeping other device sessions active.
 * @public This endpoint does not require authentication
 */
export async function InvalidateCurrentTokens(
  data: InvalidateTokensRequest,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/auth/tokens/invalidate`;
  const requestOptions = { ...options, skipAuth: true };
  return client.post<Response>(requestPath, data, requestOptions);
}
